import { render, staticRenderFns } from "./DocumentPicker.vue?vue&type=template&id=309e180d&"
import script from "./DocumentPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports